<button
  mat-tonal-button
  (click)="toggleSidenav()"
  class="active-filters-widget"
  *ngIf="showFiltersToggle"
>
  <div class="container d-flex fd-row ai-center">
    <div class="active-filters hide--xs show d-flex fd-col jc-center ai-center">
      Show&nbsp;filters
    </div>
    <div class="d-flex jc-center ai-center">
      <mat-icon
        class="icon"
        [matBadge]="activeFilters?.query?.rules?.length || null"
        matBadgeColor="warn"
        >filter_alt
      </mat-icon>
    </div>
  </div>
</button>
